import { RecordingErrorCode } from '../types/media.enums';
import { createLogger } from './logger';

const logger = createLogger(true);

/**
 * Safely stop all tracks in a MediaStream
 */
export const cleanupMediaStream = (stream: MediaStream | null): void => {
  if (!stream) return;

  stream.getTracks().forEach((track) => {
    try {
      track.stop();
      logger.info(`Stopped ${track.kind} track: ${track.label}`);
    } catch (error) {
      logger.warn(`Error stopping ${track.kind} track:`, error);
    }
  });
};

/**
 * Request media stream with proper error handling
 */
export const requestMediaStream = async (
  constraints: MediaStreamConstraints,
): Promise<MediaStream> => {
  try {
    return await navigator.mediaDevices.getUserMedia(constraints);
  } catch (error: any) {
    logger.error('Error acquiring media stream:', error);

    // Map browser errors to our error codes
    if (error.name === 'NotAllowedError') {
      throw { ...error, code: RecordingErrorCode.PERMISSION_DENIED };
    } else if (error.name === 'NotFoundError') {
      throw { ...error, code: RecordingErrorCode.DEVICE_NOT_FOUND };
    } else {
      throw { ...error, code: RecordingErrorCode.STREAM_ERROR };
    }
  }
};
